import { render } from "./ChannelPointsCustomRewardRedemptionUpdate.vue?vue&type=template&id=7911906a"
import script from "./ChannelPointsCustomRewardRedemptionUpdate.vue?vue&type=script&lang=ts"
export * from "./ChannelPointsCustomRewardRedemptionUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script